import React from "react";
import { Phone, Wrench } from "lucide-react";

const SIDES = [
  { icon: Phone, who: "You", t: "Call the manufacturer", d: "If your TV needs a warranty repair or replacement, you call the manufacturer and file the TV warranty claim with them." },
  { icon: Wrench, who: "Us", t: "We do the physical work", d: "We take the TV down and put the replacement back up." },
];

export const WarrantyHandling = () => (
  <section data-testid="warranty-handling" className="pb-14 lg:pb-16 bg-white">
    <div className="max-w-[1000px] mx-auto px-5 lg:px-8">
      <h2 className="text-2xl md:text-3xl font-extrabold text-[#0a1f44]">If your TV has a manufacturer warranty claim</h2>
      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {SIDES.map((s) => (
          <div key={s.who} data-testid={`warranty-handling-${s.who.toLowerCase()}`} className="rounded-2xl bg-white border border-slate-200 p-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-xl bg-[#eef4ff] flex items-center justify-center"><s.icon className="w-5 h-5 text-[#3b9dff]" /></span>
              <span className="text-xs font-bold uppercase tracking-widest text-slate-400">{s.who}</span>
            </div>
            <h3 className="mt-4 text-lg font-bold text-[#0a1f44]">{s.t}</h3>
            <p className="mt-1 text-slate-600 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>
      <p className="mt-4 text-sm text-slate-500">We do not handle the manufacturer claim process. The 5-Year Install Warranty above covers our installation labor only.</p>
    </div>
  </section>
);
